const documentsSubType = [
  { label: "NDA", value: "NDA" },
  { label: "MSA", value: "MSA" },
  { label: "SLA", value: "SLA" },
  { label: "T&C", value: "T_AND_C" },
  { label: "Other", value: "OTHER" },
];

export default documentsSubType;
